"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
    strokeWidth: "2",
    strokeLinejoin: "round",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    id: "path3583",
    cx: "7.9813662",
    cy: "11.668264",
    rx: "6.7829366",
    ry: "6.8026161"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
    strokeWidth: "2",
    strokeLinejoin: "round",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    id: "path3583-5",
    cx: "16.091457",
    cy: "11.69252",
    rx: "6.7829366",
    ry: "6.8026161"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    d: "m 14.33259,15.577551 3.532238,2.039339",
    id: "path3615"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1",
    d: "m 14.183859,12.745585 7.01879,4.191567",
    id: "path3615-3-5"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1",
    d: "m 15.057927,10.635618 6.603239,3.799611",
    id: "path3615-3-5-4-2"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1",
    d: "m 13.838079,7.3913335 8.669402,4.9885145",
    id: "path3615-3-5-4-2-0"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeDasharray: "none",
    strokeOpacity: "1",
    d: "m 14.90423,5.5996404 7.01879,4.191568",
    id: "path3615-3-5-6"
  })]
}));